export const config = {
  api: process.env["REACT_APP_API_ENDPOINT"] || "",
  debug: process.env["REACT_APP_DEBUG"] === "true",
  debug_step: process.env["REACT_APP_DEBUG_STEP"] === "true",
  default_country_code: process.env["REACT_APP_DEFAULT_COUNTRY_CODE"],
  sendbird: {
    appId: process.env["REACT_APP_SENDBIRD_APP_ID"] || "",
    accessToken: process.env["REACT_APP_SENDBIRD_ACCESS_TOKEN"] || "",
    userId: process.env["REACT_APP_SENDBIRD_USER_ID"] || "",
  },
  contact: {
    email: process.env["REACT_APP_CONTACT_EMAIL"] || "belong@wearesweet.co.uk",
    phone: process.env["REACT_APP_CONTACT_TEL"] || "+44 203 0701 555",
  },
  functionality: {
    chat: process.env["REACT_APP_CHAT_ENABLED"] === "true" || true,
    profile: process.env["REACT_APP_PROFILE_ENABLED"] === "true" || true,
    contact: process.env["REACT_APP_CONTACT_ENABLED"] === "true" || true,
    news: process.env["REACT_APP_NEWS_ENABLED"] === "true" || true,
    events: process.env["REACT_APP_EVENTS_ENABLED"] === "true" || true,
    resources: process.env["REACT_APP_RESOURCES_ENABLED"] === "true" || true,
  },
  google: {
    api_key: process.env["REACT_APP_GOOGLECLOUD_API_KEY"],
  },
  openweather: {
    api_key: process.env["REACT_APP_OPENWEATHER_API_KEY"],
  },
  format: {
    date: process.env["REACT_APP_FORMAT_DATE"] || "DD/MM/YYYY",
    time: process.env["REACT_APP_FORMAT_TIME"] || "H:mm",
    dateTime: process.env["REACT_APP_FORMAT_DATETIME"] || "DD/MM/YYYY H:mm",
  },
  version: process.env["REACT_APP_VERSION"] || "[dev]",
};
